import { TrendingUp } from "lucide-react";
import { zoneColors } from "./utils";

const TransitionMatrix = ({ transitions }) => {
  if (!transitions || Object.keys(transitions).length === 0) {
    return (
      <div className="reid-empty-state">
        No transitions available
      </div>
    );
  }

  return (
    <div className="reid-card">
      <h4 className="reid-card-header">
        <TrendingUp size={18} className="reid-card-header-icon" />
        Zone Transition Probabilities
      </h4>
      <div className="reid-matrix-container">
        {Object.entries(transitions).map(([fromZone, toZones]) => (
          <div key={fromZone} className="reid-matrix-row">
            <div className="reid-matrix-from">
              <span className="reid-matrix-from-label">
                From {fromZone}:
              </span>
            </div>
            <div className="reid-matrix-transitions">
              {Object.entries(toZones).map(([toZone, probability]) => (
                <span
                  key={toZone}
                  className="reid-matrix-transition"
                  style={{
                    backgroundColor: zoneColors[toZone] || zoneColors.default,
                  }}
                >
                  {toZone} ({(probability * 100).toFixed(0)}%)
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TransitionMatrix; 